var _path, _rect, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 30.9375C9.625 28.2796 11.7796 26.125 14.4375 26.125C17.0954 26.125 19.25 28.2796 19.25 30.9375V35.75H9.625V30.9375Z",
    stroke: "#E8192C",
    strokeWidth: 2.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.42363,
    height: 2.80788,
    transform: "matrix(0.721387 -0.692532 0.721387 0.692532 19.1172 34.541)",
    fill: "#E8192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 12.375C4.125 10.0968 5.97183 8.25 8.25 8.25H39.875V35.75H4.125V12.375Z",
    stroke: "#333333",
    strokeWidth: 2.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1289 19.25C17.1289 20.7164 15.8742 22 14.207 22C12.5399 22 11.2852 20.7164 11.2852 19.25C11.2852 17.7836 12.5399 16.5 14.207 16.5C15.8742 16.5 17.1289 17.7836 17.1289 19.25Z",
    stroke: "#E8192C",
    strokeWidth: 2.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 16.5H35.5209V19.25H25.4375V16.5Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 22H35.5209V24.75H28.875V22Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.6140bb12b26881220cee9622f02a8c58.svg";
export { ForwardRef as ReactComponent };